export default __webpack_public_path__ + "static/media/order-service-bullets.62ad2993.svg";